import { each } from 'lodash';
import { BaseController } from '../../base/controller';
import { ErrorsFromApi } from './accountNumber.errors';

class AccountNumberController extends BaseController {
  constructor(
    $scope,
    controllerService,
    accountNumberService,
    validationRules,
    configService,
  ) {
    'ngInject';
    super({
      $scope,
      controllerService,
      accountNumberService,
      validationRules,
      configService,
    });
  }

  get showFinanceType() {
    return this.configService.isFeatureActive(this.Features.showFinanceType);
  }

  $onChanges(changes) {
    // backend recognized error, mark field as errored
    const { apiValidationError } = changes;
    if (apiValidationError && apiValidationError.currentValue) {
      this.form.newAccountId.$setValidity(this.apiValidationError, false);
    }
  }

  $onInit() {
    this.id = this.$scope.$id;

    this.messageId = 'app.start.error.accountNumber';
    this.messages = {
      required: `${this.messageId}.required`,
      accountNumber: `${this.messageId}.invalid`,
      accountNumberBlocked: `${this.messageId}.blocked`,
      blz: `${this.messageId}.blocked`,
      ...ErrorsFromApi,
    };

    // remove api error from input when changes are made
    this.$scope.$watch('vm.account.number', (newValue) => {
      if (this.form.newAccountId) {
        this.form.newAccountId.$setValidity(this.apiValidationError, true);
      }
    });

    // Set validation rules (comma separated to set multiple rules)
    this.options = { validate: 'accountNumber,accountNumberBlocked' };

    this.setValidationRules(this.messages);
  }

  setValidationRules(messages) {
    // Get accountId validation config from tenant config
    // TODO
    const accountNumberConfig = this.configService.getFeature(
      this.Features.accountNumberValidation,
    );

    // Used to set tenant specific translation key
    let translatePrefix = '';

    if (accountNumberConfig) {
      const { translateKey } = accountNumberConfig;

      // Use given translate key as translate prefix
      if (translateKey) {
        translatePrefix = translateKey;
      }
    }

    // Set validation message for every given message type
    each(messages, (translateKey, messageKey) => {
      this.setValidationMessage(
        messageKey,
        `${translatePrefix}${translateKey}`,
      );
    });
  }

  setValidationMessage(messageKey, translateKey) {
    const name = this.configService.getTenant();
    this.$translate(translateKey, { tenant: name }).then((translation) => {
      this.messages[messageKey] = translation;
    });
  }
}

export default AccountNumberController;



// WEBPACK FOOTER //
// ./src/app/common/ui/account-number/accountNumber.controller.js